import {useState} from "react";
import "./header.scss";
import logoSvg from "../../assets/logo/velo-logo.svg";
import mapSvg from "../../assets/img/map-icon-white.svg";
import chevron from "../../assets/img/chevron-down.svg";
import menu from "../../assets/img/menu.svg";
import close from "../../assets/img/close.svg";
import { Link, useParams } from "react-router-dom";

const Header = ({langData}) => {
  //const { language, changeLang } = useModalContext();
  const { lang } = useParams();
  const temporaryUrl = 'lv/lv/';
  const [navActive, setNavActive] = useState(false);

  const scrollTo = (ref) => {
    if (ref && ref.current /* + other conditions */) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <div>
      <header className="header">
        <div className="container">
          <div className="logo" onClick={() => window.scrollTo(0, 0)}>
            <Link to={`/`} >
              <img src={logoSvg} alt="velo logo" />
            </Link>
          </div>
        </div>
        <div className="nav-button" onClick={()=>{setNavActive(!navActive)}}>
          { navActive ? 
            <>
              <img src={close} />
              <span>{ langData.menu.close }</span>
            </>
            :
            <>
              <img src={menu} />
              <span>{ langData.menu.menu }</span>
            </>
          }
        </div>
        <nav className={navActive ? "nav active": "nav"}>
          <a href={`/lv/lv/#what-is-velo`} onClick={()=>{setNavActive(false)}}>{ langData.menu.what_is_velo }</a>
          <a href={`/lv/lv/#velo-products`} onClick={()=>{setNavActive(false)}}>{ langData.menu.velo_products }</a>
          <a href={`/lv/lv/#how-to-use`} onClick={()=>{setNavActive(false)}}>{ langData.menu.how_to_use }</a>
          <Link to={`/lv/lv/faq`} onClick={()=>{setNavActive(false)}}>{ langData.menu.faq }</Link>
        </nav>
        <div className="map-link">
          <Link to={`/lv/lv/where-to-buy`}>
            <img src={mapSvg} alt="Where to buy" />
            <span>{langData.menu.where_to_buy}</span>
          </Link>
        </div>
      </header>
    </div>
  );
};

export default Header;
